<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Teslimat ve İptal/İade</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Teslimat ve İptal/İade</h1>
        </div>
      </div>
    </div>
  </section>


  <div class="container">
    <div class="row mt-xlg">
      <div class="col-md-12">
        <h2><strong>Ödeme, teslimat</strong> ve <strong>iptal/iade</strong></h2>
        <div style="font-size: 16px  !important;">

          <p><strong>Ödeme ve Teslimat</strong></p>
          <p>Ürün/hizmet satın almak için girmiş olduğunuz tüm bilgiler faturalandırma için kullanılmaktadır.</p>


          <p>Ödeme için girdiğiniz kredi kartı bilgileri iyzico sisteminin güvenlik yapılarında değerlendirilecek ve ödemeniz alınacaktır.</p>


          <p>Ödemeniz sonrasında satın almanız tamamlanacak ve satın aldığınız ürüne dair bilgiler eposta adresinize gönderilecektir ve bu bilgilerle ürünü kullanmaya başlayabileceksiniz.</p>



          <p><strong>İptal / İade</strong></p>


          <p>Eğer satın aldığınız ürünü iptal etmek siterseniz bizi aramanız yeterlidir.</p>


          <p>İadenin yapılabilmesi için ürünün kullanılmamış olması gereklidir.


          <p>Eğer satın aldığınız ürün bir hizmet ise hizmetin başlamamış olması gerekmektedir.</p>

                  <p>Eğer satın aldığınız ürün bir yazılım ise 15 takvim günü içinde iade yapılabilir.</p>

                  <p>Eğer satın aldığınız ürün bir paket ürün (video, dokuman vb.) ise sisteme giriş sonrası iade yapılamaz.</p>

        </div>
      </div>
    </div>

  </div>

  <section class="call-to-action call-to-action-default with-button-arrow call-to-action-in-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </div>
  </section>

</div>
